/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_difference_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate the percentage difference between two numbers. Order-independent comparison relative to the average, with the formula and examples.`)
};

const es_pct_difference_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula la diferencia porcentual entre dos números. Comparación independiente del orden, relativa al promedio, con la fórmula y ejemplos.`)
};

const de_pct_difference_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechne den prozentualen Unterschied zwischen zwei Zahlen. Reihenfolgeunabhängiger Vergleich relativ zum Durchschnitt, mit Formel und Beispielen.`)
};

const nl_pct_difference_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken het percentageverschil tussen twee getallen. Volgorde-onafhankelijke vergelijking ten opzichte van het gemiddelde, met formule en voorbeelden.`)
};

const fr_pct_difference_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez la différence en pourcentage entre deux nombres. Comparaison indépendante de l'ordre, relative à leur moyenne, avec la formule et des exemples.`)
};

const it_pct_difference_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola la differenza percentuale tra due numeri. Confronto indipendente dall'ordine rispetto alla media, con formula ed esempi.`)
};

const pt_br2_pct_difference_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a diferença percentual entre dois números. Comparação independente da ordem, relativa à média, com a fórmula e exemplos.`)
};

const pt_pct_difference_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a diferença percentual entre dois números. Comparação independente da ordem, relativa à média, com fórmula e exemplos.`)
};

const ja_pct_difference_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つの数値の間のパーセントの差を計算。平均に対する順序に依存しない比較を、計算式と例つきで。`)
};

const zh_pct_difference_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算两个数字之间的百分比差异。基于平均值进行与顺序无关的比较，附有公式和示例。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_difference_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_difference_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_difference_meta_description", locale)
	if (locale === "en") return en_pct_difference_meta_description(inputs)
	if (locale === "es") return es_pct_difference_meta_description(inputs)
	if (locale === "de") return de_pct_difference_meta_description(inputs)
	if (locale === "nl") return nl_pct_difference_meta_description(inputs)
	if (locale === "fr") return fr_pct_difference_meta_description(inputs)
	if (locale === "it") return it_pct_difference_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_pct_difference_meta_description(inputs)
	if (locale === "pt") return pt_pct_difference_meta_description(inputs)
	if (locale === "ja") return ja_pct_difference_meta_description(inputs)
	return zh_pct_difference_meta_description(inputs)
};